import type { StreamEvent, StreamEventType } from '../types/chat.js';

export async function* parseSSE(response: Response): AsyncGenerator<StreamEvent> {
  const reader = response.body!.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    let idx = buffer.indexOf('\n\n');
    while (idx !== -1) {
      const raw = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const event = parseBlock(raw);
      if (event) yield event;
      idx = buffer.indexOf('\n\n');
    }
  }
}

function parseBlock(block: string): StreamEvent | null {
  let event: StreamEventType = 'text';
  let dataStr = '';
  for (const line of block.split('\n')) {
    if (line.startsWith('event: ')) event = line.slice(7).trim() as StreamEventType;
    else if (line.startsWith('data: ')) dataStr += line.slice(6);
  }
  if (!dataStr) return null;
  try {
    return { type: event, data: JSON.parse(dataStr) };
  } catch {
    return null;
  }
}
